import BaseAPI from './BaseAPI';

// The Square team-member roster mirrored into the `staffs` table, under
// /staffs. Distinct from AdminAPI (auth/staff → the users/admin accounts).
class StaffAPI extends BaseAPI {
  constructor() {
    super('staffs');
  }

  list(status = 'all') {
    return this.get('/?status=' + status);
  }

  // PUT /staffs/:idStaff/locations { locationIds } → { staff }
  // Where this person may be scheduled. An empty list hands the question back
  // to Square rather than leaving them with nowhere to work.
  setLocations(idStaff, locationIds) {
    return this.put(`/${idStaff}/locations`, { body: { locationIds } });
  }

  // POST /staffs/sync → { staffs: [...] } (refetches the roster from Square)
  sync() {
    return this.post('/sync');
  }
}

export const StaffService = new StaffAPI();
export default StaffAPI;
